import o from "./highrise.es202.js";
/* empty css               */
import t from "./highrise.es177.js";
const p = /* @__PURE__ */ t(o, [["__scopeId", "data-v-82a8014d"]]);
export {
  p as default
};
//# sourceMappingURL=highrise.es89.js.map
